<template>
  <div>
    <div
      v-if="!loadComponentsState.isLoading">
      <transition name="fade">
        <router-view
          v-if="!loadComponentsState.error"
          :componentData="component"/>
      </transition>
      <ErrorMessageDesignerContainer
        v-if="loadComponentsState.error"
        :error="loadComponentsState.error" />
    </div>
  </div>
</template>

<script>
import { loadComponentById } from './api';
import ErrorMessageDesignerContainer from './ErrorMessageDesignerContainer.vue';

export default {
  components: {
    ErrorMessageDesignerContainer,
  },
  data() {
    return {
      component: null,
      saveComponentState: {
        isSaving: false,
        isSaved: false,
        error: false,
      },
      loadComponentsState: {
        isLoading: true,
        error: null,
      },
    };
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    pageComponentKey() {
      return this.$route.params.pageComponentKey;
    },
  },
  created() {
    this.loadComponentById();
  },
  methods: {
    async loadComponentById() {
      try {
        const response = await loadComponentById(this.pageDesignerKey, this.pageComponentKey);
        this.component = response.data;
        this.loadComponentsState.isLoading = false;
      } catch (error) {
        this.loadComponentsState.isLoading = false;
        this.loadComponentsState.error = error.response;
      }
    },
  },
};
</script>

<style scoped>
</style>
